import axios from "@/plugins/axios";
import { sync } from "vuex-router-sync";

export default {
    getAllInitiatives(params) {
        return axios.httpApi.get("/initiatives", { params });
    },
    getInitiative(initiative_id) {
        return axios.httpApi.get(`/initiatives/${initiative_id}`);
    },
    createInitiative(initiative) {
        initiative.button_type = "CALL_TO_ACTION"
        return axios.httpApi.post("/initiatives", initiative);
    },
    editInitiative(initiative) {
        if (!initiative.creditor_id) initiative.creditor_id = null
        const id = initiative.id
        delete initiative.id
        delete initiative.sender
        delete initiative.approved
        delete initiative.approved_at
        delete initiative.approved_by
        delete initiative.message_has_inconsistency
        delete initiative.status_history
        initiative.button_type = "CALL_TO_ACTION"

        return axios.httpApi.patch(`/initiatives/${id}`, initiative);
    },
    saveApproval(initiative) {
        const id = initiative.id
        delete initiative.id
        return axios.httpApi.patch(`/initiatives/${id}`, initiative);
    },
    createInitiativeMedia(files, folders) {
        return axios.httpApi.post('/initiatives/generate_s3_signature', { files: files, folders: folders })
    },
    uploadInitiativeMedia(url, formData) {
        return axios.axiosBase(url).post('', formData)
    },
    cloneInitiative(payload) {
        return axios.httpApi.post('/whatsapp_meta/templates/clone', payload);
    },
    syncTemplate(metaId) {
        return axios.httpApi.post(`/whatsapp_meta/${metaId}/template_sync?sync_sender=true`);
    }
}